import { createFeatureSelector, createSelector } from '@ngrx/store';
import * as fromReservation from '../reducers/reservation.reducer';

export const selectReservationState = createFeatureSelector<fromReservation.State>(
  fromReservation.reservationFeatureKey
);

export const selectReservation = createSelector(selectReservationState, state => state.reservation);
export const selectTablesAvailability = createSelector(selectReservationState, state => state.tablesAvailability);
export const selectReservationHistory = createSelector(selectReservationState, state => state.reservationHistory);
export const selectArrivalTime = createSelector(selectReservationState, state => state.arrivalTime);
export const selectReadOnlyMode = createSelector(selectReservationState, state => state.readOnlyMode);
export const selectIsSubmiting = createSelector(selectReservationState, state => state.isSubmiting);
export const selectQuickChangingStatus = createSelector(selectReservationState, state => state.quickChangingStatus);

export const selectPaymentLinkExpiresAt = createSelector(selectReservationState,state => state.paymentLinkExpiresAt);
export const selectPaymentLinkExpiresDirty = createSelector(selectReservationState,state => state.paymentLinkExpiresDirty);
